import { render, staticRenderFns } from "./MappingForm.vue?vue&type=template&id=b0ea5f0e"
import script from "./MappingForm.vue?vue&type=script&lang=js"
export * from "./MappingForm.vue?vue&type=script&lang=js"
import style0 from "./MappingForm.vue?vue&type=style&index=0&id=b0ea5f0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports